import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import ChatCard from './ChatCard';
import '../styles/chat.css';

const JDPostingPlan = () => {
  const { isDark } = useTheme();

  // Convert hex to rgba
  const hexToRgba = (hex, alpha) => {
    const safe = (hex || '').replace('#', '');
    if (safe.length !== 6) return hex;
    const r = parseInt(safe.slice(0, 2), 16);
    const g = parseInt(safe.slice(2, 4), 16);
    const b = parseInt(safe.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return (
    <div
      className="chat_spacing_sm"
      style={{
        paddingRight: '16px', // add right padding so left/right spacing are equal
      }}
    >
      <div>
        <div className="chat_spacing_md">
          {/* AI Powered Strategy Section */}
          <div className="chat_mb_lg">
            {/* AI Powered Strategy and Expected Time on same line */}
            <div className="flex items-center justify-between chat_mb_md">
              <h5 className="chat_section_heading" style={{ margin: 0 }}>
                AI Powered Strategy
              </h5>
              <span 
                className="chat_font_medium"
                style={{ 
                  fontSize: '14px',
                  color: '#22C55E',
                  lineHeight: '20px'
                }}
              >
                5-7 Days Expected Time to Find Interviews
              </span>
            </div>
            <ChatCard 
              variant="secondary" 
              size="lg" 
              rounded="xl"
              className="chat_no_shadow"
              style={{
                backgroundColor: isDark ? hexToRgba('#22C55E', 0.1) : hexToRgba('#22C55E', 0.08),
                borderColor: isDark ? hexToRgba('#22C55E', 0.2) : hexToRgba('#22C55E', 0.15),
              }}
            >
              <div className="chat_mb_sm">
                <p 
                  className="chat_font_medium chat_mb_md"
                  style={{ 
                    fontSize: '14px',
                    color: isDark ? '#F9FAFB' : '#111827',
                    lineHeight: '20px'
                  }}
                >
                  What will I do automatically:
                </p>
                <ul 
                  className="chat_spacing_sm"
                  style={{ 
                    listStyle: 'none',
                    padding: 0,
                    margin: 0
                  }}
                >
                  {[
                    'Post to LinkedIn, Naukri, and your careers page',
                    'Monitor and collect applications 24/7',
                    'Parse resumes and rank candidates by fit',
                    'Send personalized outreach messages',
                    'Schedule interviews with top candidates',
                    'Send reminders and collect feedback'
                  ].map((item, idx) => (
                    <li 
                      key={idx}
                      className="flex items-start chat_gap_sm"
                      style={{ marginBottom: '8px' }}
                    >
                      <span 
                        style={{ 
                          color: '#22C55E',
                          fontSize: '16px',
                          lineHeight: '20px',
                          marginRight: '8px',
                          flexShrink: 0
                        }}
                      >
                        ✓
                      </span>
                      <span 
                        className="chat_font_normal"
                        style={{ 
                          fontSize: '14px',
                          color: isDark ? '#D1D5DB' : '#374151',
                          lineHeight: '20px'
                        }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </ChatCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JDPostingPlan;
